import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { ChannelFeatures } from '../../chat/interfaces/IChannel';
import { PermissionsService } from '../../chat/services/permissions.service';

@Directive({
  selector: '[hasChannelFeature]',
  standalone: false,
})
export class HasChannelFeatureDirective {
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<unknown>,
    private permissionsService: PermissionsService
  ) {}

  @Input() set hasChannelFeature(features: ChannelFeatures[]) {
    if (this.permissionsService.checkChannelFeatures(features)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
